import React, { useMemo, useState } from 'react';

import { getCookie } from '../../../utils/cookie';
import { IMenuConfigurationModel } from '../models/menuConfigurationModel';

import { MenuContainer } from './layout/MenuContainer';
import { MenuContext } from './layout/MenuContext';
import { IMenuContextState } from './layout/MenuContextState';
import ThemeEnum from './layout/shared/themeSelector/themeEnum';
import HeaderEnum from './layout/topLevelMenu/headerEnum';

const Header: React.FC = () => {
  const [selectedHeader, setSelectedHeader] = useState(HeaderEnum.None);
  const [, setSelectedTheme] = useState(ThemeEnum.lightTheme);
  const [menuConfig] = useState<IMenuConfigurationModel>({} as IMenuConfigurationModel);
  let themeCookie = getCookie('theme');

  if (themeCookie === '') {
    themeCookie = `${ThemeEnum.lightTheme}`;
  }

  const getCurrentTheme = parseInt(themeCookie ?? '0');

  const state = useMemo(() => {
    return {
      selectedHeader: selectedHeader,
      setSelectedHeader: setSelectedHeader,
      selectedTheme: getCurrentTheme,
      setSelectedTheme: setSelectedTheme,
      menuConfig: menuConfig,
      rootConfigUrl: '',
    } as IMenuContextState;
  }, [selectedHeader, getCurrentTheme, menuConfig]);

  return (
    <MenuContext.Provider value={state}>
      <MenuContainer />
    </MenuContext.Provider>
  );
};

export default Header;
